export default __webpack_public_path__ + "static/media/openPortrait.dc636a82.png";